import { render, staticRenderFns } from "./inputText.vue?vue&type=template&id=b4b0a9d0"
import script from "./inputText.vue?vue&type=script&lang=ts"
export * from "./inputText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports